module.exports = __webpack_public_path__ + "static/media/team.1cfebc01.png";